import { ref, computed } from 'vue'
import Storage from './storage'

class PermissionsManager {
  static _permissions = ref([]) // réactif

  static async init() {
    PermissionsManager.insertPermissionsStyle(['see-permission-loader'])
    await PermissionsManager.loadPermissions()
    setInterval(() => {
      PermissionsManager.loadPermissions()
    }, 5000)
  }

  static async loadPermissions() {
    let permissions = []
    try {
      const userData = Storage.get('userData')
      if (userData) {
        const isSuperAdmin =
          userData.role === 'super-admin' ||
          userData.role === 'admin' ||
          userData.isSuperAdmin === true

        if (isSuperAdmin) {
          // Super-admin gets all known permissions
          permissions = [
            'dashboard', 'dashboard:stats',
            'customers', 'customers:view', 'customers:create', 'customers:edit', 'customers:delete',
            'sponsorship', 'sponsorship:view', 'sponsorship:edit',
            'kyc', 'kyc:view', 'kyc:validate',
            'disputes', 'disputes:view', 'disputes:manage',
            'restaurants', 'restaurants:view', 'restaurants:create', 'restaurants:edit', 'restaurants:delete',
            'catalog', 'catalog:view', 'catalog:create', 'catalog:edit', 'catalog:delete',
            'orders', 'orders:view', 'orders:manage', 'orders:cancel',
            'riders', 'riders:view', 'riders:create', 'riders:edit', 'riders:delete',
            'deliveries', 'deliveries:view', 'deliveries:manage',
            'finance', 'finance:view', 'finance:transactions', 'finance:payouts',
            'marketing', 'marketing:view', 'marketing:campaigns', 'marketing:coupons', 'marketing:broadcast',
            'notifications', 'notifications:view', 'notifications:send',
            'settings', 'settings:view', 'settings:edit',
            'adminProducts', 'adminProducts:create', 'adminProducts:edit', 'adminProducts:delete',
            'debts', 'debts:view', 'debts:manage',
            'team-members', 'team-members:create', 'team-members:edit', 'team-members:delete',
            'milestones', 'history', 'profile',
          ]
        } else if (Array.isArray(userData.permissions) && userData.permissions.length > 0) {
          permissions = userData.permissions
        }
      }
    } catch (error) {
      console.log('🚀 ~ PermissionsManager ~ loadPermissions ~ error:', error)
    }
    permissions.push('see-interface')

    // Met à jour les permissions réactives
    PermissionsManager._permissions.value = permissions

    PermissionsManager.insertPermissionsStyle(permissions)
  }

  static insertPermissionsStyle(permissions) {
    const css = PermissionsManager.generatePersmissionsCss(permissions)
    PermissionsManager.insertOrUpdateCSS(css)
  }

  static generatePersmissionsCss(permissions) {
    let css = `[permission] {display: none; --visible-display:block} [permission-click] {pointer-events: none;} [permission=none] {display: var(--visible-display);}`
    permissions.forEach(permission => {
      const escapedPermission = permission.replace(/:/g, '\\:')
      css += `[permission=${escapedPermission}] {display: var(--visible-display);} [permission-click=${escapedPermission}] {pointer-events: all;}`
    })
    return css
  }

  static insertOrUpdateCSS(cssContent) {
    let styleElement = document.getElementById('dynamic-permissions-style')

    if (!styleElement) {
      styleElement = document.createElement('style')
      styleElement.id = 'dynamic-permissions-style'
      document.head.appendChild(styleElement)
    }

    styleElement.innerHTML = cssContent
  }

  static getMainPermissions(permissions) {
    const mainPermissions = new Set()

    permissions.forEach(permission => {
      const mainPermission = permission.split(':')[0]
      mainPermissions.add(mainPermission)
    })

    return Array.from(mainPermissions)
  }

  /**
   * Retourne un computed qui réagit automatiquement
   * @param {string} permission
   */
  static has(permission) {
    return computed(() =>
      PermissionsManager._permissions.value.includes(permission),
    )
  }

  static getAllPermissions() {
    return PermissionsManager._permissions.value
  }

  /**
   * Plugin Vue: permet de faire app.use(PermissionsManager)
   */
  static install(app) {
    // accès complet
    app.config.globalProperties.$permission = PermissionsManager
  }
}

export default PermissionsManager
